import { createElement } from "react";
import { SurveyElementBase, ReactElementFactory } from "survey-react-ui";
import "./FilePreviewComponent.css";
import pdfIcon from "../../icons/pdf.svg";
import docIcon from "../../icons/doc.svg";
import pptIcon from "../../icons/ppt.svg";
import imgIcon from "../../icons/img.svg";
import fileIcon from "../../icons/file.svg";
import xlsIcon from "../../icons/xls.svg";
import trashIcon from "../../icons/close-small.svg";

class FilePreviewComponent extends SurveyElementBase {
    constructor(props) {
        super(props);
        this.state = {
            question: props.question
        };
    }

    getFileIcon = (fileName) => {
        const extension = fileName.split('.').pop().toLowerCase();
        switch (extension) {
            case 'pdf':
                return pdfIcon;
            case 'doc':
            case 'docx':
            case 'rtf':
                return docIcon;
            case 'ppt':
            case 'pptx':
                return pptIcon;
            case 'png':
            case 'jpg':
            case 'gif':
            case 'tiff':
            case 'svg':
            case 'bmp':
            case 'jpeg':
                return imgIcon;
            case 'xls':
            case 'xlsx':
            case 'numbers':
                return xlsIcon;
            default:
                return fileIcon;
        }
    };

    isImageFile = (fileName) => { const extension = fileName.split('.').pop().toLowerCase(); return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'tiff'].includes(extension); };
    downloadFile = (fileItem) => {
        fetch(fileItem.content)
            .then((response) => response.blob())
            .then((blob) => {
                const file = new File([blob], fileItem.name, { type: fileItem.type });
                const reader = new FileReader();
                reader.onload = (e) => {
                    const a = document.createElement("a");
                    a.href = e.target.result;
                    a.download = fileItem.name;
                    a.click();
                };
                reader.readAsDataURL(file);
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    render() {
        const { question } = this.state; if (!question || !question.value) { return null; }
        return (
            <div className="file-preview-container">
                <div className="file-tiles">
                    {question.value.map((fileItem, i) => {
                        const isImage = this.isImageFile(fileItem.name);
                        return (
                            <div className="file-tile" key={i} onClick={() => this.downloadFile(fileItem)}>

                                {!question.isReadOnly && (
                                    <button className="file-delete-button"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            this.state.question.removeFile(fileItem.name);
                                        }} title="Remove file">
                                        <img src={trashIcon} alt="Delete" />
                                    </button>
                                )}
                                <div className="file-tile-icon">
                                    {
                                        isImage && fileItem.content ?
                                            (
                                                <div className="file-tile-preview">
                                                    <img src={fileItem.content} alt={fileItem.name} />
                                                </div>
                                            )
                                            : (
                                                <img src={this.getFileIcon(fileItem.name)} alt={`${fileItem.name} icon`} />
                                            )
                                    }
                                </div>
                                <div className="file-tile-name" title={fileItem.name}>
                                    {fileItem.name}</div></div>);
                    })}</div></div>);
    }
}

ReactElementFactory.Instance.registerElement("sv-file-preview", (props) => {
    return createElement(FilePreviewComponent, props);
});

export default FilePreviewComponent;